var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(285 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flessibilit\\xE0",
    transform: "translate(-104 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M3.371,63.393s-5.693-9.719-2.283-18.97S11,37.365,20.12,27.966C31.186,16.55,38.958,15.922,48.828,20.908c5.586,2.821,6.49,14.425,15.379,21.63,8.015,6.5,1.477,17.566-2.73,19.291a20.655,20.655,0,0,1-7.063,1.725S48.09,86.92,29.242,86.119,3.371,63.393,3.371,63.393Z",
    transform: "translate(286.1 616.06)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3281",
    "data-name": "Raggruppa 3281",
    transform: "translate(22596.701 -19985.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1837",
    "data-name": "Tracciato 1837",
    d: "M113,145.076l14.14-8.165a2.873,2.873,0,0,1,4.309,2.488v5.033c.042,0,.083,0,.125,0h12.274a3.135,3.135,0,0,1,3.135,3.135V164.95a3.135,3.135,0,0,1-6.27,0V150.7h-9.138c-.042,0-.083,0-.125,0v5.033a2.873,2.873,0,0,1-4.309,2.488L113,150.051A2.873,2.873,0,0,1,113,145.076Z",
    transform: "translate(-22421 20481)",
    fill: "#bfd7ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1834",
    "data-name": "Tracciato 1834",
    d: "M145.543,145.076,131.4,136.91a2.873,2.873,0,0,0-4.309,2.488v5.033c-.042,0-.083,0-.125,0H114.7a3.135,3.135,0,0,0-3.135,3.135v14.884c0,1.731,1.4,2.456,3.135,2.456a3.135,3.135,0,0,0,3.135-3.135V150.7h9.138c.042,0,.083,0,.125,0v5.033a2.873,2.873,0,0,0,4.309,2.488l14.14-8.165A2.873,2.873,0,0,0,145.543,145.076Z",
    transform: "translate(-22391.779 20522.617)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1836",
    "data-name": "Tracciato 1836",
    d: "M145.543,145.076,131.4,136.91a2.873,2.873,0,0,0-4.309,2.488v5.033c-.042,0-.083,0-.125,0H114.7a3.135,3.135,0,0,0-3.135,3.135V164.95a3.135,3.135,0,1,0,6.27,0V150.7h9.138c.042,0,.083,0,.125,0v5.033a2.873,2.873,0,0,0,4.309,2.488l14.14-8.165A2.873,2.873,0,0,0,145.543,145.076Z",
    transform: "translate(-22391.779 20487.199)",
    fill: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1835",
    "data-name": "Tracciato 1835",
    d: "M113,145.076l14.14-8.165a2.873,2.873,0,0,1,4.309,2.488v5.033c.042,0,.083,0,.125,0h12.274a3.135,3.135,0,0,1,3.135,3.135v29.931a3.318,3.318,0,0,1-3.135,3.342,3.156,3.156,0,0,1-3.135-3.159V150.7h-9.138c-.042,0-.083,0-.125,0v5.033a2.873,2.873,0,0,1-4.309,2.488L113,150.051A2.873,2.873,0,0,1,113,145.076Z",
    transform: "translate(-22421 20506.68)",
    fill: "#03518c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibility);
export default __webpack_public_path__ + "static/media/flexibility.4a936c5229ce36874f97c32b6036354f.svg";
export { ForwardRef as ReactComponent };